module.exports = __webpack_public_path__ + "img/edit-icon.b20e36e.png";